
import { saveAs } from "file-saver";
import exceljs from "exceljs";
//--------------------------------------------------------------------------------------------
import { 
    mimeTypeMap, MyDate
} from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
//--------------------------------------------------------------------------------------------
export default function Export({
    filterUserList
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!filterUserList.length){
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;                
        const rows = filterUserList.map(post => [
                post.submitter,
                post.totalHours,
                post.type, 
                post.notes,
                post.dateCreated,
                post.submitter,
                post.dateUpdated ?? "",
                post.approver,
                post.notify ?? "", 
                post.status,
                post.dateCompleted ?? "",
                post.comments,
        ])
        //--------------------------------------------------------------------------------------------------------
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "Requester", filterButton: true},
                { name: "Total Hours", filterButton: true},
                { name: "Type", filterButton: true},
                { name: "Notes", filterButton: true},
                { name: "Date Created", filterButton: true},
                { name: "Submitter", filterButton: true},
                { name: "Date Updated", filterButton: true},
                { name: "Approver", filterButton: true},
                { name: "Notified At", filterButton: true},
                { name: "Status", filterButton: true},
                { name: "Review Time", filterButton: true},
                { name: "Approver Comments", filterButton: true},
            ],
            rows: rows,
        });
        //--------------------------------------------------------------------------------------------------------
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //--------------------------------------------------------------------------------------------------------
        for(let rowIndex = 2; rowIndex <= worksheet.rowCount; rowIndex++){
            worksheet.getRow(rowIndex).alignment = { vertical: "middle", horizontal: "center"};
        }
        worksheet.getColumn(2/*#*/).alignment = { horizontal: "center", wrapText: true };
        worksheet.getColumn(2/*#*/).width = 30/*#*/;
        //--------------------------------------------------------------------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `absence request export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return (
        <span onClick = {exportFunc}>Export</span>
    )
}